import React, {useRef, useEffect, useState, useContext} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { IsAuthContext } from '../../../../../../app/App';

/**
 * Champ de saisie du numéro de bipeur (ou de table, selon le paramètre de la section).
 *
 * @param {number} sectionId - Section du ticket, pour retrouver le terme à afficher
 */
const BipeurInput = (props) =>{
    const t =useTranslate()
    const { authParam } = useContext(IsAuthContext)
    const section = authParam.sections.find(value=>value.id==props.sectionId)
    const labelKey = (section?.advanceparams?.bipeur_label=='table') ? 'tableNumber' : 'bipeurNumber'
    const bipeurInput = useRef('')

    const handleChange = (e) =>{
        if (props.error) {
            props.setError(false)
        }
        props.setBipeurVal(e.target.value.replace(/\D/g,''))
    }

    const handleClick = () =>{
        if (props.bipeur_field && props.bipeur_required && props.bipeurVal=='') {
            props.setError(true)
        }
        else if (props.bipeur_field) {
            props.editBipeurNumber()
        }
    }

    useEffect(function () {
        if (props.error) {
            bipeurInput.current.focus()
        }
    },[props.error])

    return(
        <div className={(props.isFor=='payment') ? "mt-3 d-flex align-items-center" : ""}>
            <label className='me-2' style={{ whiteSpace: 'nowrap' }}>{t(labelKey) + ' : '}</label>
            <input className={'me-2 ' + ((props.error) ? 'form-control is-invalid' : 'form-control')} type="text" ref={bipeurInput} value={props.bipeurVal} onChange={(e)=>handleChange(e)}/>
            {(props.showButton) && 
                <button className="btn btn-sm btn-primary mt-2" onClick={()=>handleClick()}>{(props.loading) ? <div className="spinner-border spinner-border-sm"></div> : t('edit')}</button>
            }
        </div>
    )
}

export default BipeurInput;